import {
  getAutocompleteService,
  getPlacesService,
  getAutocompleteSessionToken
} from "../google/maps/places";
import type { AutocompletePrediction, AutocompleteSessionToken, PlaceResult } from "../google/maps/types";

let currentSessionToken: AutocompleteSessionToken | null = null;

export const _resetSessionToken = (): void => {
  currentSessionToken = null;
};

const getSessionToken = async (): Promise<AutocompleteSessionToken> => {
  currentSessionToken = currentSessionToken ? currentSessionToken : await getAutocompleteSessionToken();
  return currentSessionToken;
};

export const getPlacePredictions = async (query: string): Promise<AutocompletePrediction[]> => {
  const autocompleteService = await getAutocompleteService();

  const { predictions } = await autocompleteService.getPlacePredictions({
    input: query,
    types: ["address"],
    sessionToken: await getSessionToken()
  });
  return predictions;
};

export const getPlaceDetails = async (placeId: string): Promise<PlaceResult> => {
  const [placesService, sessionToken] = await Promise.all([getPlacesService(), getSessionToken()]);

  currentSessionToken = null; // Reset the session token after the first use with getDetails.

  // Unfortunately, the PlacesService.getDetails method does not return a promise, so we have to wrap it.
  return new Promise((resolve, reject) => {
    placesService.getDetails({
      placeId,
      sessionToken,
      fields: ["address_components", "geometry", "formatted_address", "place_id"]
    }, (result, status) => {
      result ? resolve(result) : reject(status); // TODO: sure we should reject? Maybe resolve null + bugsnag the error.
    });
  });
};
